import React, { useState } from 'react';
import './index.css';
import { Link, useNavigate } from 'react-router-dom';
import serviceIcon3dPrint from '../../assets/images/service-icon-3dprint.webp';
import serviceIconApps from '../../assets/images/service-icon-apps.webp';
import serviceIconConsulting from '../../assets/images/service-icon-consulting.webp';
import serviceIconWebsite from '../../assets/images/service-icon-website.webp';

interface Service {
  title: string;
  description: string;
  details: string;
  link?: string;
}

const serviceLinks = [
  {
    label: 'Web Development in Northwest Arkansas',
    icon: serviceIconWebsite,
    path: '/services/websites',
  },
  {
    label: 'Mobile App Development in Northwest Arkansas',
    icon: serviceIconApps,
    path: '/services/appdev',
  },
  {
    label: 'Cloud Consulting in Northwest Arkansas',
    icon: serviceIconConsulting,
    path: '/services/consulting',
  },
  {
    label: '3D Printing in Northwest Arkansas',
    icon: serviceIcon3dPrint,
    path: '/services/3dprints',
  },
];

const Services: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="services-container">
      <section className="services-intro">
        <h1>Hogcloud Services</h1>
        <p>
          Hogcloud provides website development, custom app development, cloud
          software, AI automation, and custom 3D printing for small businesses,
          creators, families, and local organizations.
        </p>
        <nav className="local-service-links" aria-label="Northwest Arkansas service pages">
          {serviceLinks.map((serviceLink) => (
            <Link key={serviceLink.path} to={serviceLink.path} aria-label={serviceLink.label}>
              <img src={serviceLink.icon} alt="" aria-hidden="true" />
            </Link>
          ))}
        </nav>
      </section>

    </div>
  );
};

export default Services;
